// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".playkit-fill-container_nM{width:100%;height:100%;overflow:hidden}", "",{"version":3,"sources":["webpack://./node_modules/@playkit-js/common/dist/ui-common/injected-component/injected-component.scss"],"names":[],"mappings":"AAAA,2BAAgB,UAAU,CAAC,WAAW,CAAC,eAAe","sourcesContent":[".fill-container{width:100%;height:100%;overflow:hidden}"],"sourceRoot":""}]);
// Exports
export var fillContainer = "playkit-fill-container_nM";
export default ___CSS_LOADER_EXPORT___;
